import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsNeonSignSkin = {
  ...textEffectsSharedSkin,
  'text-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'shadow-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'shadow-opacity': {
    type: 'ALPHA',
    defaultValue: '0.5',
  },
  'shadow-blur': {
    type: 'NUMBER',
  },
  'inner-animation-speed': {
    type: 'NUMBER',
    defaultValue: '12.6',
  },
  'disable-inner-animation': {
    type: 'CSSString',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsNeonSignSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsNeonSign': TextEffectsNeonSignSkin,
};

export default generateSkinDefaults(TextEffectsNeonSignSkinDefinitionMap);
